<template>
  <div>
    <canvas ref="pdfCanvas"></canvas>
  </div>
</template>
<script>
//npm i pdfjs-dist@2.10.377
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.js'
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js';

// Configura el worker para pdfjs
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export default {
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 80,
    },
    height: {
      type: Number,
      default: 150,
    },
    target:{
      type: String,
      default:"_blank",
    },
  },
  mounted() {
    this.loadPdfThumbnail(this.pdfUrl);
  },
  methods: {
    async loadPdfThumbnail(url) {
      try {
        // Cargar el PDF desde la URL
        const pdf = await pdfjsLib.getDocument(url).promise;

        // Obtener la primera página del PDF
        const page = await pdf.getPage(1);
        
        // Calcular la escala para que la miniatura se ajuste a las dimensiones proporcionadas
        const viewport = page.getViewport({ scale: 0.2 });
        const scale = Math.min(this.width / viewport.width, this.height / viewport.height);
        const scaledViewport = page.getViewport({ scale });

        const canvas = this.$refs.pdfCanvas;
        const context = canvas.getContext('2d');

        // Configurar el tamaño del canvas de acuerdo al viewport escalado
        canvas.width = scaledViewport.width;
        canvas.height = scaledViewport.height;

        // Renderizar la página en el lienzo
        await page.render({
          canvasContext: context,
          viewport: scaledViewport
        }).promise;
      } catch (error) {
        console.error("Error al cargar el PDF:", error);
      }
    }
  }
};
</script>

<style scoped>

canvas {
  border: 1px solid #ddd;
  width: 100%;
  height: auto;
}
/**/
</style>